'use strict';

const { toBoolean } = require('./wishlist');
const { toastErrorMessage, toastSuccessMessage, appendToastMessage } = require('./wishlistToast');
/* eslint-disable */

var knownWishlistStatus = new Map();

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, currentElement, icon, pid) {
    $.spinner().stop();

    if (data.success) {
        if (currentElement.hasClass('already-added-to-wishlist')) {
            icon.removeClass('wishlist-heart').addClass('wishlist-heart-o');
            currentElement.removeClass('already-added-to-wishlist');
            knownWishlistStatus.set(String(pid), false);
        } else {
            icon.removeClass('wishlist-heart-o').addClass('wishlist-heart');
            currentElement.addClass('already-added-to-wishlist');
            knownWishlistStatus.set(String(pid), true);
        }
        appendToastMessage(toastSuccessMessage(data.msg));
    } else {
        appendToastMessage(toastErrorMessage(data.msg));
    }
}

function clearPendingState($el) {
    $el.removeClass('wishlist-pending').removeAttr('aria-disabled').removeAttr('aria-busy').removeAttr('tabindex');
}

function setWishlistIconState(currentElement, icon, isInWishlist) {
    if (isInWishlist) {
        icon.removeClass('wishlist-heart-o').addClass('wishlist-heart');
        currentElement.addClass('already-added-to-wishlist');
    } else {
        icon.removeClass('wishlist-heart').addClass('wishlist-heart-o');
        currentElement.removeClass('already-added-to-wishlist');
    }
    clearPendingState(currentElement);
}

function resolveTiles($tiles, giveUpOnUnknown) {
    var unresolvedPids = [];
    $tiles.each(function () {
        var $tile = $(this);
        var pid = $tile.data('pid');
        if (knownWishlistStatus.has(String(pid))) {
            setWishlistIconState($tile, $tile.find('i'), knownWishlistStatus.get(String(pid)));
        } else if (giveUpOnUnknown) {
            clearPendingState($tile);
        } else if (pid && unresolvedPids.indexOf(pid) === -1) {
            unresolvedPids.push(pid);
        }
    });
    return unresolvedPids;
}

function hydrateWishlistIcons() {
    if (!toBoolean($('#isloggedIn').val())) {
        resolveTiles($('.wishlistTile.wishlist-pending'), true);
        return;
    }

    var statusUrl = $('#wishlistStatusUrl').val();
    var $tiles = $('.wishlistTile[data-pid]');
    if (!statusUrl || !$tiles.length) {
        return;
    }

    var pids = resolveTiles($tiles, false);
    if (!pids.length) {
        return;
    }

    $.ajax({
        url: statusUrl,
        type: 'get',
        dataType: 'json',
        data: { pids: pids.join(',') },
        success: function (data) {
            if (data && data.success && data.status) {
                Object.keys(data.status).forEach(function (pid) {
                    if (!knownWishlistStatus.has(pid)) {
                        knownWishlistStatus.set(pid, data.status[pid]);
                    }
                });
            }
            resolveTiles($tiles, true);
        },
        error: function () {
            resolveTiles($tiles, true);
        }
    });
}

module.exports = {
    hydration: {
        run: hydrateWishlistIcons
    },
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile', function (e) {
            if ($(this).hasClass('wishlist-pending')) {
                return;
            }
            if(toBoolean($('#isloggedIn').val())) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                var currentElement = $(this);
                var type ='post';
                var icon = currentElement.find($('i'));
                var url = currentElement.attr('addproducturl');
                var pid = currentElement.closest('.product').data('pid');
                var wishlistProduct = currentElement.hasClass('already-added-to-wishlist');
                var wishlistError = currentElement.data('wishlisterror');
                if(wishlistProduct) {
                    type = 'get';
                    url = currentElement.attr('removeproducturl');
                }
                var optionId = currentElement.closest('.product-detail').find('.product-option').attr('data-option-id');
                var optionVal = currentElement.closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
                optionId = optionId || null;
                optionVal = optionVal || null;
                if (!url || !pid) {
                    return;
                }

                $.spinner().start();
                $.ajax({
                    url: url,
                    type: type,
                    dataType: 'json',
                    data: {
                        pid: pid,
                        optionId: optionId,
                        optionVal: optionVal
                    },
                    success: function (data) {
                        displayMessageAndChangeIcon(data, currentElement, icon, pid);
                    },
                    error: function (err) {
                        $.spinner().stop();
                        appendToastMessage(toastErrorMessage(wishlistError));

                        if (wishlistProduct) {
                            currentElement.addClass('already-added-to-wishlist');
                        }
                    }
                });
            } else {
                var pid = $(this).data('pid');
                sessionStorage.setItem("guestWishlistItems", JSON.stringify(pid));
                $('#wishlist-login-modal').modal('show')
            }
        });
    }
};
